import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const usePinConversation = () => {
  const { pinConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: (payload: IDObject) => conversation.pin(payload.id),
    onSuccess: (conversation, payload) => {
      pinConversation(payload.id);
    },
  });

  return mutation;
};
